import { useI18n } from '@nanning/ui';
import { GROUP_MESSAGES } from './messages';

type Vars = Record<string, string | number>;

/**
 * 站点级 t()：先查本站文案，再回落共享文案；支持 {var} 插值。
 */
export function useT() {
  const base = useI18n();
  return {
    ...base,
    t: (key: string, vars?: Vars) => {
      const raw =
        GROUP_MESSAGES[base.locale]?.[key] ??
        GROUP_MESSAGES.en?.[key] ??
        GROUP_MESSAGES.zh?.[key] ??
        base.t(key);
      if (!vars) return raw;
      return Object.entries(vars).reduce((acc, [k, v]) => acc.replaceAll(`{${k}}`, String(v)), raw);
    },
  };
}

/** 图片路径：基于构建 base（./），保证静态部署与子路径部署都可用。 */
export function assetUrl(local: string): string {
  return `${import.meta.env.BASE_URL}${local}`;
}
